class MarqueeComponent extends HTMLElement {
  connectedCallback() {
    // If reduced motion, disable animation
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.setAttribute("data-disabled", "");
      return;
    }

    this.wrapper = this.querySelector('[ref="wrapper"]');
    this.content = this.querySelector('[ref="content"]');
    this.items = this.querySelector('[ref="marqueeItems[]"]');

    if (!this.wrapper || !this.content || !this.items) return;

    this.speedFactor = Number(this.dataset.speedFactor || 25); // px/sec baseline
    this.setSpeedAndRepeat(); 
    // Re-run after layout/fonts settle (prevents the initial 98% fill)
requestAnimationFrame(() => this.setSpeedAndRepeat());
setTimeout(() => this.setSpeedAndRepeat(), 200);
window.addEventListener("load", () => this.setSpeedAndRepeat(), { passive: true });

if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(() => this.setSpeedAndRepeat());
}


    // Recalc on resize
    this._onResize = this.setSpeedAndRepeat.bind(this);
    window.addEventListener("resize", this._onResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._onResize);
  }

  setSpeedAndRepeat() {
    // Clear previous clones (keep first items block)
    const repeated = this.content.querySelectorAll(".marquee__repeated-items");
    repeated.forEach((node, idx) => {
      if (idx > 0) node.remove();
    });

    const gap = this.getGapValue();

    // 1. IMPROVED: Get width more accurately
    const viewportWidth = window.innerWidth;
    let totalWidth = this.items.offsetWidth; // offsetWidth is more reliable here

    // 2. SAFETY CHECK: If it's too small, don't break
    if (totalWidth <= 0) totalWidth = 200; 

    // 3. FORCE EXTRA CLONES: We clone until it's 3x the width instead of 2x
    // This physically prevents the gap from ever being visible
    while (totalWidth < viewportWidth * 3) {
      const clone = this.items.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      this.content.appendChild(clone);
      totalWidth += clone.offsetWidth + gap;
    }

    // 4. FIX FOR REVERSE: Ensure speed is consistent
    const distance = totalWidth / 2;
    const seconds = Math.max(5, distance / this.speedFactor);

    this.style.setProperty("--marquee-speed", `${seconds}s`);
  }

  getGapValue() {
    // Read --marquee-gap from computed style (fallback 24)
    const styles = getComputedStyle(this);
    const gap = parseFloat(styles.getPropertyValue("--marquee-gap")) || 24;
    return gap;
  }
}

customElements.define("marquee-component", MarqueeComponent);
